var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "fill-height",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-text', [_c('v-row', [_vm._l(_vm.pages, function (page, index) {
    return [_c('v-col', {
      key: page._id
    }, [_c('side-item', _vm._b({
      on: {
        "click": function ($event) {
          return _vm.$emit('input', index);
        }
      }
    }, 'side-item', {
      page,
      value: _vm.value,
      index
    }, false))], 1)];
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }